import axios from "axios";
import store from '@/state/store'

export default {
  created: function () {
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;

    if (store.getters['auth/token']) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${store.getters['auth/token']}`;
    }

    axios.interceptors.response.use(response => response, async (error) => {
      const status = error.response ? error.response.status : null;

      if (status !== 401 || window.location.pathname === "/login") {
        return Promise.reject(error);
      }

      if (!store.getters['auth/refreshToken']) {
        window.location.href = '/logout'
      }

      const originalRequest = error.config;

      if (originalRequest.url === '/security/refresh-token') {
        window.location.href = '/logout'
        return Promise.reject(error);
      }
      
      if (!originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const { data } = await axios.post('/security/refresh-token', { refreshToken: store.getters['auth/refreshToken'] });
      
          await store.dispatch('auth/refreshTokens', data);
          axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
          originalRequest.headers['Authorization'] = `Bearer ${data.token}`;
      
          return axios(originalRequest);
        } catch (error) {
          window.location.href = '/logout'
        }
      }

      return Promise.reject(error);
    });
  },
  methods: {
    // GET CALLS
    async apiGet(url, params = {}, fetchAll = false) {
      if (fetchAll) {
        params.limit = 5000;
      }
      const { data, status } = await axios.get(url, { params });
      if (status === 200) {
        if (fetchAll && data.meta.cursor.next) {
          return data.data.concat(await this.apiGet(data.meta.cursor.next, params, fetchAll));
        } else {
          return data;
        }
      } else if (status === 204) {
        return { data: [] };
      }
    },
    async apiGetPublic(url, params = {}) {
      const { data, status } = await axios.get(url, { params, transformRequest: (data, headers) => { delete headers.common['Authorization'] } });
      if (status === 200) {
        return data;
      } else if (status === 204) {
        return { data: [] };
      }
    },
    async apiGetFile(url, params = {}, accept) {
      const { data, status } = await axios.get(url, { params, headers: { 'Accept': accept }, responseType: 'blob' });
      if (status === 200) {
        return data;
      } else if (status === 204) {
        return { data: [] };
      }
    },

    // DELETE & UNDELETE CALLS
    async apiDelete(url) {
      await axios.delete(url);
    },
    async apiUndelete(url) {
      await axios({ method: 'UNDELETE', url});
    },

    // PATCH CALLS
    async apiPatch(url, data) {
      await axios.patch(url, data);
    },

    // POST CALLS
    async apiPost(url, data, returnData = false) {
      return await axios.post(url, data).then((data) => {
        if (returnData) {
          return data.data;
        } else {
          return data.headers['x-resource-id'];
        }
      })
    },
    async apiPostPublic(url, data, returnData = false) {
      return await axios.post(url, data, { headers: { 'Authorization': null }}).then(() => {
        if (returnData) {
          return data.data;
        } else {
          return data.headers['x-resource-id'];
        }
      })
    },
    async apiPostFile(url, data) {
      return await axios.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } }).then(({ headers }) => {
        return headers['x-resource-id'];
      })
    },

    // IMPERSONATE USER
    async apiImpersonateUser(email) {
      axios.defaults.headers.common['X-Switch-User'] = email;
    },
    async apiCleanImpersonatedUser() {
      delete axios.defaults.headers.common['X-Switch-User'];
    }
  }
};